// @ts-strict-ignore
import { NextPageContext } from 'next'
import { getAuthCookie } from './cookies'

export async function createServerEnvironmentFromCtx(ctx: NextPageContext) {
  const { createServerEnvironment: createEnvironment } = await import(
    /* webpackChunkName: "RelayServerEnrivonment" */'../api/graphql/relay/serverEnvironment'
  )

  if (!ctx?.req) {
    console.warn('No request context found when creating relay server environment')
  }

  return createEnvironment(ctx?.req ? getAuthCookie(ctx.req) : undefined)
}
